export const calculateSupplementsTotalPrice = (data,currentCurrency) => {
  let val = 0;

  data.forEach((dt) => {
    val += (currentCurrency === 'IQD' ? dt.iqd : dt.price) || 0;
  });
  return val;
};
